import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  bannerData: null,
  recentNews: null,
  trendingTags: null,
  topNews: null
};

// *************************** Fetch Banner ****************************
const fetchBannerStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchBannerSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, bannerData: action.bannerData, loading: false };
};

const fetchBannerFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************ Fetch Trending Tags ************************
const fetchTrendingTagsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchTrendingTagsSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, trendingTags: action.trendingTags, loading: false };
};

const fetchTrendingTagsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Recent News *************************
const fetchRecentNewsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchRecentNewsSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, recentNews: action.recentNews, loading: false };
};

const fetchRecentNewsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************** Fetch Top News ***************************
const fetchTopNewsStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchTopNewsSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, topNews: action.topNews, loading: false };
};

const fetchTopNewsFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  [Types.FETCH_BANNER_START]: fetchBannerStart,
  [Types.FETCH_BANNER_FAILURE]: fetchBannerFailure,
  [Types.FETCH_BANNER_SUCCESS]: fetchBannerSuccess,

  [Types.FETCH_TRENDING_TAGS_START]: fetchTrendingTagsStart,
  [Types.FETCH_TRENDING_TAGS_FAILURE]: fetchTrendingTagsFailure,
  [Types.FETCH_TRENDING_TAGS_SUCCESS]: fetchTrendingTagsSuccess,

  [Types.FETCH_RECENT_NEWS_START]: fetchRecentNewsStart,
  [Types.FETCH_RECENT_NEWS_FAILURE]: fetchRecentNewsFailure,
  [Types.FETCH_RECENT_NEWS_SUCCESS]: fetchRecentNewsSuccess,

  [Types.FETCH_TOP_NEWS_START]: fetchTopNewsStart,
  [Types.FETCH_TOP_NEWS_FAILURE]: fetchTopNewsFailure,
  [Types.FETCH_TOP_NEWS_SUCCESS]: fetchTopNewsSuccess
};

// Create and Export Reducer
export const newsReducer = createReducer(INITIAL_STATE, HANDLERS);
